import { m, useReducedMotion, AnimatePresence } from "framer-motion";
import React, { PropsWithChildren } from "react";
import { useInView } from "react-intersection-observer";

export interface AnimationProps //added since we get errors "'children' does not exist on type 'IntrinsicAttributes & ModuleLayoutProps & RefAttributes<HTMLDivElement>'"
  extends React.ComponentPropsWithoutRef<"section"> {
  animation?: string;
}

const animations = {
  fadeIn: {
    trigger: true,
    animate: {
      opacity: 1,
    },
    exit: {
      opacity: 0,
    },
  },
  fadeInOut: {
    trigger: false,
    animate: {
      opacity: 1,
    },
    exit: {
      opacity: 0,
    },
  },
  fadeUp: {
    trigger: true,
    animate: {
      opacity: 1,
      y: 0,
    },
    exit: {
      opacity: 0,
      y: 200,
    },
  },
  fadeUpDown: {
    trigger: false,
    animate: {
      opacity: 1,
      y: 0,
    },
    exit: {
      opacity: 0,
      y: 200,
    },
  },
  none: {
    initial: {},
    animate: {},
    exit: {},
  },
};

const transitionDuration = 0.45;

export const AnimationWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  // This only works with components mounting and unmounting?
  return (
    <AnimatePresence mode={"wait"} initial={true}>
      {children}
    </AnimatePresence>
  );
};

// Make sure to use reduce motion for accessibility users

export const MotionDiv = React.forwardRef<HTMLDivElement, AnimationProps>(
  function MotionDivComponent({ children, animation }, ref) {
    const [inRef, inView] = useInView({
      triggerOnce: animation ? animations[animation].trigger : true,
      threshold: [0.3, 0.9],
    });

    const shouldReduceMotion = useReducedMotion();
    const selectAnimation = !shouldReduceMotion
      ? animation
        ? animations[animation]
        : animations["none"]
      : animations["none"];

    return (
      <div ref={inRef}>
        <m.div
          ref={ref}
          variants={selectAnimation}
          animate={inView ? "animate" : "exit"}
          transition={{
            duration: transitionDuration,
            delay: 0.1,
          }}
        >
          {children}
        </m.div>
      </div>
    );
  },
);
